import type { FileUploadItem } from '@gov-nx/core/hooks/File/fileUpload.types';
import { FileState } from '@gov-nx/core/hooks/File/fileUpload.types';

export const isAllUploaded = (files: FileUploadItem[]) =>
	files.every(
		(file) => file.state === FileState.success || file.state === FileState.error
	);
